{
  "pt": {
    "navbar": {
      "customer": {
        "after_care": "Pós-venda",
        "dashboard": "Painel de controlo",
        "decisions": "Decisões",
        "documents": "Documentos",
        "inspirations": "Inspirações",
        "installments": "Finanças",
        "profile": "O seu perfil",
        "projectinfo": "Informações",
        "question_lists": "FAQ",
        "surveys": "Inquéritos",
        "ticket": {
          "new": "Nova conversa"
        },
        "tickets": "Conversas",
        "units": "Como construído"
      },
      "employee": {
        "all_projects": "Projetos",
        "client": "Perfil {client}",
        "contacts": "Contactos",
        "customer": "Cliente",
        "dashboard": "Painel de controlo",
        "employee": "Membro da equipa",
        "overview": "Visão geral",
        "partner": "Parceiro",
        "profile": "O seu perfil",
        "project": {
          "after_care": "Pós-venda",
          "decisions": "Decisões",
          "documents": "Documentos",
          "email_conversations": "E-mails recebidos",
          "info": "Informações",
          "installments": "Finanças",
          "milestones": "Marcos",
          "news": "Feed de notícias",
          "question_lists": "FAQs",
          "sales": "Vendas",
          "surveys": "Inquéritos",
          "tasks": "Tarefas",
          "todos": "Tarefas"
        },
        "projects": "Projetos",
        "ticket": {
          "new": "Nova conversa"
        },
        "tickets": "Conversas"
      },
      "landmarks": {
        "employee": {
          "client": {
            "primary": "Navegação principal",
            "secondary": "Navegação secundária"
          }
        }
      },
      "partner": {
        "contacts": "Contactos",
        "dashboard": "Painel de controlo",
        "profile": "O seu perfil",
        "project": {
          "after_care": "Pós-venda",
          "decisions": "Decisões",
          "documents": "Documentos",
          "tickets": "Conversas"
        },
        "projects": "Projetos"
      },
      "topnavbar": {
        "company": "Organização",
        "helpcenter": "Centro de ajuda",
        "inviteManageMembers": "Convidar e gerir membros",
        "logout": "Terminar sessão",
        "profile": "Perfil",
        "searchTeam": "Pesquisar organização",
        "selectTeam": "Selecionar organização",
        "settings": "Definições",
        "team": "Equipa"
      }
    }
  }
}
